export const cloneObject = obj => {
    if (typeof obj !== 'object') {
        return {};
    } else {
        return JSON.parse(JSON.stringify(obj));
    }
};

export const removeKeys = (data, keyToRemove = []) => {
    if (Array.isArray(keyToRemove)) {
        const updatedObj = keyToRemove.reduce((acc, key) => {
            const { [key]: _, ...newObj } = acc;
            return newObj;
        }, data);
        return updatedObj;
    }
    const { [keyToRemove]: _, ...newObj } = data;
    return newObj;
};